<template>
  <h3 class="view-sub-header__title mb-5 mt-2">
    <slot></slot>
  </h3>
</template>

<script>
export default {
  name: "SubtitleComponent",
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables.scss";
.view-sub-header__title {
  @include font-size(25px);
  color: $grey-darker;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  display: flex;
  align-items: center;

  @media #{map-get($display-breakpoints, 'lg-and-down')} {
    @include font-size(20px);
  }
}
</style>
